module.exports = __webpack_public_path__ + "static/media/23-7.ae9119b0.mp3";